<template>
  <div>
  <div class="head-font"><b>近期赛事</b> Upcoming Competitions</div>
    <!--近期赛事-->
    <div class="content">
        <div v-if="websitePageMatchList.length>0">
          <MatchList :websitePageMatchList="websitePageMatchList" v-for="(item, index) in websitePageMatchList" :key="index" :item="item"/>
        </div>
        <div class="empty" v-else>
          暂无赛事
        </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import matchFun from '@comm/utils/matchFun'
import MatchList from '@comm/components/MatchList'
export default {
  name: 'RecentMatch',
  data () {
    return {
      matchFun: matchFun,
      websitePageMatchList: [] // 赛事列表
    }
  },
  components: {
    MatchList,
  },
  created: function () {
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.programPageMatchList({
        programId: this.$route.query.programId,
        pageNum: 1,
        pageSize: 6,
        keyWord: -1,
        status: -1
      }).then(res => {
        if (res.status === 0) {
          this.websitePageMatchList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    matchClick (id, programId) {
      store.commit('match/MATCH_CHANGE_ACTIVE_MENU', 1)
      this.$router.push({name: 'MatchDetail', query: {matchId: id, programId: programId}})
    }
  }
}
</script>

<style lang="scss" scoped>
.head-font{
  width: 1200px;margin: 0 auto;margin-top:40px;margin-bottom:15px;font-size:18px;color:#000;
}

//列表页
.content{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
    
  }
  .empty{
    width: 100%;
    margin-top: 100px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/RecentMatch.vue